module.exports = __webpack_public_path__ + "img/photo-43.0efb313e.webp";